import React from 'react';
import useSheet from 'app/jss';
import classNames from 'classnames';
import { Sine } from 'gsap';
import { omit } from 'lodash';
import * as Enter from 'app/utils/animations/enter';
import * as Leave from 'app/utils/animations/leave';
import AnimatedGroup from 'app/components/commons/AnimatedGroup';

type Props = {
  classes: Object,
  className?: string,
  children?: any,
  isOtherState?: boolean,
};

const defaultProps = {
  className: '',
  children: undefined,
  isOtherState: false,
};

function FriendDetailsPanel({ classes, className, children, isOtherState, ...otherProps }: Props) {
  const enterParams = {
    duration: 0.3,
    ease: Sine.easeInOut,
    direction: isOtherState ? 'left' : 'right',
  };
  const leaveParams = {
    duration: 0.3,
    ease: Sine.easeInOut,
    direction: isOtherState ? 'left' : 'right',
    simultaneous: true,
  };

  return (
    <AnimatedGroup
      {...omit(otherProps, 'sheet')}
      className={classNames(classes.panel, className)}
      onEnter={Enter.slide(enterParams)}
      onLeave={Leave.slide(leaveParams)}
    >
      {children}
    </AnimatedGroup>
  );
}

FriendDetailsPanel.defaultProps = defaultProps;

function applyStyles(theme: Theme) {
  return {
    panel: {
      display: 'flex',
      cursor: 'auto',
      backgroundColor: theme.color.basis6,
      flexShrink: 0,
      minHeight: 60,
      fontSize: 18,
    },
  };
}

export default useSheet(applyStyles)(FriendDetailsPanel);
